import { UserRole } from "@allbesmart/web-app-keycloak-auth";
import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import Keycloak from "keycloak-js";
import { AvailableRoutes } from "../enums/available-routes";

export class SalesGuard {
  public static goToLicenses: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const keycloak = inject(Keycloak);

    if (keycloak.hasRealmRole(UserRole.SALES) && !keycloak.hasRealmRole(UserRole.ROOT) && !keycloak.hasRealmRole(UserRole.ADMIN)
        && !state.url.includes(AvailableRoutes.LICENSES)) {
      return router.createUrlTree([AvailableRoutes.LICENSES]);
    } else {
      return true;
    }
  }
}